<template>
  <div class="m-content">
    <div class="m-portlet m-portlet--mobile">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption" style="width: 100%;">
          <!-- SEARCH -->
          <div id="searchBox" style="width: 50%;"></div>
        </div>
        <div class="m-portlet__head-tools filter_product_tools">
          <!-- RESET -->
          <div id="resetQuery"></div>
        </div>
      </div>
      <div class="m-portlet m-portlet--mobile m-portlet--body-progress-">
        <div class="m-portlet__body">
          <div class="row">
            <!-- CURRENT REFINEMENTS -->
            <h5
              style="margin-left: 2em; margin-top: .5em;"
              v-show="activeFilters"
            >{{ labels.active_filters }} :</h5>
            <div id="currentRefinements"></div>
          </div>
          <div class="row" style="margin: 15px;">
            <div class="col-md-5"></div>
            <div class="col-md-4">
              <button
                type="button"
                class="btn btn-primary btn-elevate btn-circle btn-icon"
                @click="scrollToResults"
                :style="showResultsBtnClass"
              >{{ labels.see_results }}</button>
            </div>
          </div>
          <!-- ADVANCED FILTERS -->
          <advanced-filters :search="search"></advanced-filters>

          <div class="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
            <div class="alert alert-light alert-elevate helper_container" role="alert">
              <div class="alert-icon alert-icon-top">
                <i class="flaticon-information kt-font-brand"></i>
              </div>
              <div class="alert-text" style="margin-left:20px">
                <p v-html="labels.product_filters_helper_text" style="margin-bottom:0"></p>
              </div>
            </div>
          </div>

          <filters :search="search"></filters>
        </div>
      </div>
      <div class="row outer">
        <div class="col-lg-12">
          <div id="statsTop"></div>
          <div id="paginationTop"></div>
          <!-- RESULTS -->
          <results ref="resultBlock" :canExport="canExport" :search="search" :results="results"></results>
          <!-- PAGINATION -->
          <div id="statsFooter"></div>
          <div id="paginationFooter"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Dependencies
import { mapState, mapGetters, mapActions } from 'vuex';
import * as algoliasearch from 'algoliasearch';
import instantsearch from 'instantsearch.js';
import {
  searchBox,
  hits,
  currentRefinements,
  pagination,
} from 'instantsearch.js/es/widgets';
import {
  connectClearRefinements,
  connectStats,
} from 'instantsearch.js/es/connectors';
// Mixins
import Uuid from '../../../assets/js/mixins';
import duplicateAction from '../../../assets/js/duplicateMixin';
import deleteProductAction from '../../../assets/js/deleteProductMixin';
// Components
import Results from './Results';
import AdvancedFilters from './AdvancedFilters';
import Filters from './Filters';

const defaultImage = require('../../../assets/img/placeholder-product.jpg');

export default {
  name: 'ShowProducts',
  mixins: [Uuid, duplicateAction, deleteProductAction],
  components: {
    AdvancedFilters,
    Results,
    Filters,
  },
  data() {
    return {
      search: null,
      activeFilters: false,
      results: false,
      canExport: false,
      searchReset: false,
    };
  },
  watch: {
    search: {
      handler() {
        if (
          this.search.helper
          && this.search.helper._queryId !== 1
          && !this.canExport
        ) {
          this.canExport = true;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      labels: (state) => state.labels,
      selectedProductIds: (store) => store.products.selectedProductIds,
      allSelected: (store) => store.products.allSelected,
      lastSearch: (store) => store.products.lastSearch,
    }),
    ...mapGetters([
      'canEditProduct',
      'canDeleteProduct',
      'canDuplicateProduct',
    ]),
    showResultsBtnClass() {
      this.$nextTick(function () {
        if (this.search && this.search.helper && this.search.helper) {
          return this.search.helper._queryId === 1 ? 'opacity: 0.3;' : '';
        }
        return 'opacity: 0.3;';
      });
    },
  },
  methods: {
    ...mapActions('products', [
      'setSelectedProducts',
      'toggleCheckBoxes',
      'storeLastQuery',
      'storeLastQueryURL',
    ]),
    thumbnailBuilder(hit) {
      const my = this;
      let html = `
                <div id="thumb_${hit.productId}" class="
                m-portlet--rounded 
                m-portlet 
                m-portlet--tabs 
                m-portlet--head-solid-bg 
                m-portlet--head-sm 
                ${hit.archived ? 'product_archived' : ''}">
                    <label class="m-checkbox" for="${hit.productId}">
                        <input id="${
  hit.productId
}" name="product_checkbox" type="checkbox" data-value="${
  hit.productId
}" class="product_checkbox"/>
                        <span></span>
                    </label>

                    <div class="m-portlet__body">
                        ${hit.isLeader ? "<i class='fa fa-crown leader-icon'></i>" : ''}
                        <h5>${my.showThumbnailInfo(hit, 'collectionName')}</h5>
                        <h5>${my.showThumbnailInfo(hit, 'name')}</h5>
                        <h5>${my.showThumbnailInfo(hit, 'brandName')}</h5>

                        <div class="thumbnail-image-wrapper">
                            <img class="thumb-img" src="${hit.mainPhoto
                              || defaultImage}" alt="" height="200">
                        </div>

                        <div class="m-form__actions m-form__actions">
                            <div class="row justify-content-center">
                                <a href="manage-products/product/preview?productId=${
  hit.productId
}" data-id="${
  hit.productId
}" class="previewLink btn btn-primary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill"><i class="la la-eye"></i></a>
            `;
      if (this.canEditProduct) {
        html += `<a href="#" data-id="${hit.productId}" class="editLink btn btn-primary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill"><i class="la la-edit"></i></a>`;
      }
      if (this.canDuplicateProduct) {
        html += `<a href="#" data-id="${hit.productId}" class="duplicateLink btn btn-primary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill"><i class="la la-copy"></i></a>`;
      }
      if (this.canDeleteProduct) {
        html += `<a href="#" data-id="${hit.productId}" data-name="${hit.name}" class="deleteLink btn btn-info btn-outline-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill"><i class="la la-trash"></i></a>`;
      }

      html += '</div></div></div>';

      if (
        (my.allSelected
          && this.selectedProductIds.indexOf(hit.productId) === -1)
        || (!my.allSelected
          && this.selectedProductIds.indexOf(hit.productId) !== -1)
      ) {
        setTimeout(() => {
          $(`#${hit.productId}`).prop('checked', true);
        }, 50);
      }

      return html;
    },
    showThumbnailInfo(hit, attribute) {
      return hit
        && hit._highlightResult
        && hit._highlightResult.hasOwnProperty(attribute)
        ? hit._highlightResult[attribute].value
        : hit[attribute] || '';
    },
    goToPreview(id) {
      this.$router.push({ name: 'PreviewProduct', query: { productId: id } });
    },
    goToEdit(id) {
      this.$router.push({ name: 'ProductFormExt', query: { productId: id } });
    },
    facetPosition(filter) {
      return this.search.helper
        ? this.search.helper.state.facets.indexOf(filter)
        : -2;
    },
    createResetWidget() {
      const my = this;
      // Create the render function
      const renderClearRefinements = (renderOptions, isFirstRender) => {
        const { hasRefinements, refine, widgetParams } = renderOptions;

        if (isFirstRender) {
          const button = document.createElement('button');
          const att = document.createAttribute('class');
          att.value = 'btn btn-success btn-sm';
          button.setAttributeNode(att);
          button.textContent = this.labels.clear_filters;

          button.addEventListener('click', () => {
            if (my.search.helper) {
              my.search.helper.state.facets = [];
              my.search.helper.state.query = '';
              my.search.helper.state.restrictSearchableAttributes = [];
              my.searchReset = true;
            }
            refine();
            setTimeout(() => {
              // Disable export button on reset
              my.canExport = false;
              if (my.selectedProductIds.length) {
                my.toggleCheckBoxes(false);
                my.setSelectedProducts(null);
              }
            }, 300);
          });

          widgetParams.container.appendChild(button);
        }
        widgetParams.container.querySelector('button').disabled = !hasRefinements
          && this.search.helper
          && !this.search.helper.state.restrictSearchableAttributes.length
          && !this.search.helper.state.query;
        this.activeFilters = (hasRefinements
            && Object.keys(this.search.helper.state.disjunctiveFacetsRefinements)
              .length)
          || (this.search.helper && this.search.helper.state.query);
      };

      // Create the custom widget
      const customClearRefinements = connectClearRefinements(
        renderClearRefinements,
      );

      // Instantiate the custom widget
      this.search.addWidget(
        customClearRefinements({
          container: document.querySelector('#resetQuery'),
          cssClasses: {
            button: ['btn btn-success btn-sm'],
          },
        }),
      );
    },
    customStatsWidget(selector) {
      const my = this;
      const renderStats = (renderOptions, isFirstRender) => {
        const {
          hitsPerPage, page, nbHits, nbPages,
        } = renderOptions;

        let summary = '';
        my.results = nbHits;
        if (nbHits > 1) {
          summary += `Total ${my.getPageStats(
            page,
            hitsPerPage,
            nbHits,
            nbPages,
          )} sur ${nbHits} ${my.labels.records}`;
        } else if (nbHits === 1) {
          summary += `1 ${my.labels.result}`;
        } else {
          summary += `${my.labels.no_results}`;
        }

        if (document.querySelector(`#${selector}`)) {
          document.querySelector(`#${selector}`).innerHTML = `
                    <div class="ais-Stats">
                        <span class="ais-Stats-text">${summary}</span>
                    </div>
                `;
        }
      };

      const customStats = connectStats(renderStats);

      this.search.addWidget(
        customStats({
          container: `#${selector}`,
        }),
      );
    },
    initInstantSearch() {
      const my = this;
      // 2. Create an interactive search box
      this.createResetWidget();

      this.search.addWidget(
        searchBox({
          container: document.getElementById('searchBox'),
          placeholder: `${my.labels.search} ${my.labels.products}`,
          cssClasses: {
            root: 'form-group',
            input: 'form-control m-input',
            submit: 'search-box-icon',
            reset: 'search-box-icon',
          },
          queryHook(query, search) {
            search(query);
            if (my.selectedProductIds.length) {
              my.toggleCheckBoxes(false);
              my.setSelectedProducts(null);
            }
          },
        }),
      );

      this.customStatsWidget('statsTop');
      this.customStatsWidget('statsFooter');

      this.search.addWidget(
        hits({
          container: document.getElementById('hits'),
          escapeHTML: false,
          templates: {
            empty: my.labels.no_results,
            item(hit) {
              return my.thumbnailBuilder(hit);
            },
          },
        }),
      );
      this.search.addWidget(
        currentRefinements({
          container: '#currentRefinements',
          excludedAttributes: [],
          transformItems(items) {
            const filteredItems = items.filter(
              (item) => item.attribute !== 'hasCommentCIP'
                && item.attribute !== 'isNaos'
                && item.attribute !== 'hasINCI',
            );
            return filteredItems.map((item) => {
              if (
                item.attribute === 'archived'
                || item.attribute === 'commercialized'
              ) {
                item.refinements.map((refinement) => {
                  refinement.label = my.$options.filters.capitalize(
                    my.labels[refinement.label],
                  );
                });
              }
              return {
                ...item,
                label: my.labels.productFilters[item.label],
              };
            });
          },
        }),
      );
      this.search.addWidget(
        pagination({
          container: '#paginationTop',
          scrollTo: document.getElementById('topMarker'),
        }),
      );
      this.search.addWidget(
        pagination({
          container: '#paginationFooter',
          scrollTo: document.getElementById('topMarker'),
        }),
      );

      this.search.start();

      // Set event listeners
      this.$nextTick(() => {
        // Add event listener for actions
        $(document).on('click', '.previewLink', function (e) {
          e.preventDefault();
          my.storeLastQuery(my.search.helper.state);
          my.storeLastQueryURL(my.search.helper.lastResults._rawResults);
          const id = $(this).attr('data-id');
          my.goToPreview(id);
        });

        $(document).on('click', '.editLink', function (e) {
          e.preventDefault();
          my.storeLastQuery(my.search.helper.state);
          const id = $(this).attr('data-id');
          my.goToEdit(id);
        });

        $(document).on('click', '.duplicateLink', function (e) {
          e.preventDefault();
          const id = $(this).attr('data-id');
          my.triggerDuplicateAction(id);
        });

        $(document).on('click', '.deleteLink', function (e) {
          e.preventDefault();
          const id = $(this).attr('data-id');
          const name = $(this).attr('data-name');
          my.triggerDeleteAction(id, name, my.search);
        });

        $(document).on('input', '.product_checkbox', function (event) {
          // Update selected product array
          const productId = $(this).attr('data-value');
          my.setSelectedProducts(productId);
        });
      });
    },
    getPageStats(page, hitPerPage, nbHits, totalPages) {
      const from = page * hitPerPage;
      const to = page + 1 === totalPages ? nbHits : from + hitPerPage;
      return `${from} - ${to}`;
    },
    scrollToResults() {
      const { top } = $('#statsTop').offset();
      $('html').animate({ scrollTop: top - 100 }, 500);
    },
  },
  mounted() {
    this.initInstantSearch();
    const my = this;
    window.addEventListener('unload', () => {
      my.storeLastQuery(my.search.helper.state);
    });
  },
  created() {
    const my = this;
    // 1. Instantiate the search
    this.search = instantsearch({
      indexName: `${process.env.ENV_SHORTNAME}_products`,
      searchClient: algoliasearch(
        process.env.ALGOLIA_APP_ID,
        process.env.ALGOLIA_SEARCH_KEY,
      ),
      routing: true,
      searchParameters: {
        hitsPerPage: 50,
        distinct: true,
        facetingAfterDistinct: true,
        attributesToRetrieve: [
          'brandName',
          'productId',
          'collectionName',
          'name',
          'mainPhoto',
          'objectID',
          'archived',
          'isLeader',
        ],
        attributesToHighlight: ['brandName', 'collectionName', 'name'],
      },
      searchFunction(helper) {
        helper.search();
      },
    });
    // If router query at time of load we keep product selection
    if (
      this.$router.referer
      && this.$router.referer.meta
      && (!this.$router.referer.meta.hasOwnProperty('instruction')
        || this.$router.referer.meta.instruction !== 'saveQuery')
    ) {
      if (my.selectedProductIds.length) {
        my.toggleCheckBoxes(false);
        my.setSelectedProducts(null);
      }
    }
  },
  beforeDestroy() {
    $(document).off('click', '.duplicateLink');
    $(document).off('click', '.deleteLink');
    $(document).off('click', '.previewLink');
    $(document).off('click', '.editLink');
    $(document).off('input', '.product_checkbox');
  },
};
</script>

<style>
.ais-CurrentRefinements-list {
  list-style: none;
  display: flex;
}
.ais-CurrentRefinements-item {
  background: #092938;
  color: #ffffff;
  border-radius: 1.2em;
  margin-right: 2px;
  padding: 0.35em;
}
.ais-CurrentRefinements-item button {
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
.ais-CurrentRefinements-categoryLabel {
  margin-left: 0.55em;
  margin-right: 0.15em;
}
.ais-Pagination-list {
  list-style: none;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
a[class^="ais-"] {
  text-decoration: none;
}
.ais-Pagination-link {
  display: block;
  border: 1px solid #c4c8d8;
  border-radius: 5px;
  -webkit-transition: background-color 0.2s ease-out;
  transition: background-color 0.2s ease-out;
  padding: 0 10px;
  color: #000;
}
.ais-Pagination-item {
  margin-left: 0.3rem;
  font-size: 1.6em;
}
.ais-Pagination-item--selected a {
  background: #092938;
  color: #ffcc01;
}
.ais-SearchBox-input:disabled {
  background: #000;
}
.ais-SearchBox-form {
  display: flex;
}
.search-box-icon {
  border-left: none;
  box-shadow: none;
  outline: none;
  border-radius: 0.25em;
}
.kt-checkbox {
  display: inline-block;
  position: relative;
  padding-left: 20px;
  /*margin-bottom: 10px;*/
  text-align: left;
  cursor: pointer;
  font-size: 0.9rem;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.kt-checkbox.left {
  padding-left: 0;
}
.kt-checkbox span {
  border-radius: 3px;
  background: none;
  position: absolute;
  top: 1px;
  left: 0;
  height: 15px;
  width: 15px;
  border: 1px solid #d1d7e2;
}

.kt-checkbox input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.kt-checkbox span::after {
  content: "\2714";
  position: absolute;
  display: none;
  top: 45%;
  left: 30%;
  margin-left: -2px;
  margin-top: -6px;
  width: 5px;
  height: 10px;
  border-width: 0 2px 2px 0 /*rtl:ignore*/ !important;
  /*-webkit-transform: rotate(45deg) !*rtl:ignore*!;*/
  /*transform: rotate(45deg) !*rtl:ignore*!*/
}
.kt-checkbox input:checked ~ span::after {
  display: block;
}
.ais-Stats {
  padding: 0 2em;
}
#resetQuery {
  position: absolute;
  right: 5%;
}
#searchBox .form-control {
  margin-bottom: 0;
}
.m-portlet__head.filters {
  background-color: #002738;
}
.m-portlet__head.filters .m-portlet__head-text {
  color: #f5eb62;
  font-size: 1.4rem;
}
.m-portlet
  .m-portlet__head.filters
  .m-portlet__head-tools
  .m-portlet__nav
  .m-portlet__nav-item
  .m-portlet__nav-link.m-portlet__nav-link--icon
  i {
  color: #f5eb62;
}
.ais-Hits-item .m-portlet--rounded:hover {
  -webkit-box-shadow: 0px 0px 8px 7px #ffcc01;
  -moz-box-shadow: 0px 0px 8px 7px #ffcc01;
  box-shadow: 0px 0px 8px 7px #ffcc01;
  cursor: pointer;
}
.helper_container.alert {
  background-color: rgb(254 251 216);
  color: #092938;
  display: flex;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  padding: 1rem 2rem;
  margin: 0 0 20px 0;
  border-radius: 0.4em;
  box-shadow: 0 0 13px 0 rgba(82, 63, 105, 0.1);
}
.alert-icon alert-icon-top {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -ms-flex-line-pack: stretch;
  align-content: stretch;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 1.25rem 0 0;
  color: #092938;
}
.alert-text {
  align-self: center;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  padding: 2px 7px;
}
.alert-icon i {
  font-size: 2.4rem;
}
.m-portlet__body h5 em {
  font-weight: bold;
  color: #1b7e9a;
}
.product_archived {
  background-color: rgba(158, 158, 158, 0.22);
}

.leader-icon{
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Products/AllProducts/ShowProducts.vue